<template>
  <component
    :is="tag"
    class="base-display-title"
    :class="[
      `base-display-title--size-${size}`,
      `base-display-title--font-${font}`,
      `base-display-title--tone-${tone}`,
      `text-${align}`,
    ]"
  >
    <span class="base-display-title__inner">
      <base-koblenz-arrow
        v-if="arrow"
        class="base-display-title__arrow"
        :color="resolvedArrowColor"
      />
      <span>
        <template v-if="title">
          {{ title }}
        </template>
        <slot v-else />
      </span>
    </span>
  </component>
</template>

<script setup lang="ts">
import BaseKoblenzArrow from '~/components/base/KoblenzArrow.vue'

defineOptions({
  name: 'BaseDisplayTitle',
})

const props = defineProps({
  title: { type: String, default: '' },
  tag: { type: String, default: 'p' },
  align: { type: String, default: 'left' },
  size: { type: String, default: 'default' },
  font: { type: String, default: 'display' },
  tone: { type: String, default: 'default' },
  arrow: { type: Boolean, default: false },
  arrowColor: { type: String, default: '' },
})

const resolvedArrowColor = computed(
  () => props.arrowColor || 'var(--brand-primary)',
)
</script>

<style scoped>
.base-display-title {
  margin: 0;
  text-transform: uppercase;
  color: var(--color-text-strong);
}

.base-display-title__inner {
  display: inline-flex;
  align-items: center;
  gap: 0.7em;
}

.base-display-title__arrow {
  font-size: 0.95em;
}

.base-display-title--font-display {
  font-family: var(--font-display);
  line-height: 0.92;
  letter-spacing: 0.1em;
}

.base-display-title--font-sans {
  font-family: var(--font-sans);
  line-height: 1.05;
  letter-spacing: 0.16em;
  font-weight: 600;
}

.base-display-title--tone-default {
  color: var(--color-text-strong);
}

.base-display-title--tone-accent {
  color: var(--color-accent-soft);
}

.base-display-title--tone-subtle {
  color: var(--color-text-muted);
}

.base-display-title--size-default {
  font-size: clamp(0.9rem, 1.7vw, 1.15rem);
}

.base-display-title--size-hero {
  font-size: clamp(1.25rem, 3vw, 2rem);
}

.base-display-title--size-compact {
  font-size: 0.88rem;
}
</style>
